<template>
  <div class="mt-8">
    <vs-row class="flex justify-between items-center my-4">
      <h5 class="mb-4 xl:mb-0"><i class="dot"></i> {{ title }}</h5>
      <div class="flex gap-4" v-if="!readonly">
        <AlertUserSelector ref="refUserSelector" class="w-full" type="" v-model="selectedUser" :readonly="readonly" style="display: none" :additional-data="['phone', 'mobile']" @select="onSelectUsers" />
        <vs-button color="secondary" @click="addItems">항목추가</vs-button>
        <vs-button color="secondary" type="border" @click="deleteItems" :disabled="selected.length === 0">선택삭제</vs-button>
        <vs-button color="secondary" type="border" @click="refreshEnterExitTime">QR 데이터 불러오기</vs-button>
      </div>
    </vs-row>

    <div class="overflow-x-auto">
      <vs-table :multiple="!readonly" v-model="selected" :data="localValue" class="w-full table" noDataText="데이터가 없습니다" style="min-width: 1500px">
        <template slot="thead">
          <vs-th class="table-header"> <div class="w-full text-center">성명</div></vs-th>
          <vs-th class="table-header" style="min-width: 100px"> <div class="w-full text-center">직위(직책)</div></vs-th>
          <vs-th class="table-header" style="min-width: 140px"> <div class="w-full text-center">연락처</div></vs-th>
          <vs-th class="table-header" style="min-width: 100px"> <div class="w-full text-center">건설업 기초안전보건 교육 수료증</div></vs-th>
          <vs-th class="table-header" style="min-width: 100px"> <div class="w-full text-center">내국인/외국인</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center">건강정보(수축/이완)</div></vs-th>
          <vs-th class="table-header" style="min-width: 100px"> <div class="w-full text-center">작업가능 여부</div></vs-th>
          <vs-th class="table-header" style="min-width: 100px"> <div class="w-full text-center">교육만료 일자</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center">입문시간</div></vs-th>
          <vs-th class="table-header"> <div class="w-full text-center">출문시간</div></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr" style="box-shadow: none !important; transform: none !important">
            <vs-td>
              <div class="print-input" style="min-width: 100px">{{ tr.userName }}</div>
            </vs-td>

            <vs-td class="text-center">
              <div v-if="readonly" class="print-input">{{ tr.직위직책 }}</div>
              <vs-select v-else class="w-full flex-1" autocomplete v-model="tr.직위직책">
                <vs-select-item v-for="option in 직위직책옵션" :key="option" :text="option" :value="option" />
              </vs-select>
            </vs-td>

            <vs-td class="text-center">
              <div v-if="readonly" class="print-input">{{ tr.연락처 }}</div>
              <ml-input v-else :readonly="readonly" v-model="tr.연락처" class="w-full flex-1" @click.stop />
            </vs-td>

            <vs-td class="text-center">
              <file-uploader v-model="tr.기초안전보건교육수료증" :readonly="readonly" />
            </vs-td>

            <!-- 내국인/외국인 -->
            <vs-td class="text-center">
              <vs-radio v-model="tr.내국인외국인" vs-value="내국인" :vs-name="`내국인외국인${indextr}`" class="mr-4" :disabled="readonly">내국인</vs-radio>
              <vs-radio v-model="tr.내국인외국인" vs-value="외국인" :vs-name="`내국인외국인${indextr}`" class="mr-4" :disabled="readonly">외국인</vs-radio>
            </vs-td>

            <!-- 건강정보(수축/이완) -->
            <vs-td class="text-center">
              <div style="display: flex; flex-direction: row; align-items: center">
                <number-input v-model="tr.건강정보_수축" :readonly="readonly" :min="0" :max="500" @click.stop style="width: 60px" />
                <div style="margin: 0 5px">/</div>
                <number-input v-model="tr.건강정보_이완" :readonly="readonly" :min="0" :max="500" @click.stop style="width: 60px" />
              </div>
            </vs-td>

            <!-- 작업가능 여부 -->
            <vs-td>
              <vs-radio v-model="tr.작업가능여부" vs-value="가능" :vs-name="`작업가능여부${indextr}`" class="mr-4" :disabled="readonly">가능</vs-radio>
              <vs-radio v-model="tr.작업가능여부" vs-value="불가능" :vs-name="`작업가능여부${indextr}`" class="mr-4" :disabled="readonly">불가능</vs-radio>
            </vs-td>

            <!-- 교육만료 일자 -->
            <vs-td class="text-center">
              <div v-if="readonly" class="print-input">{{ tr.교육만료일자 }}</div>
              <date-selector v-else v-model="tr.교육만료일자" :readonly="readonly" />
            </vs-td>

            <!-- 입문시간 -->
            <vs-td class="text-center">
              <div v-if="readonly" class="print-input">{{ tr.입문시간 }}</div>
              <time-selector v-else v-model="tr.입문시간" :readonly="readonly" />
            </vs-td>

            <!-- 출문시간 -->
            <vs-td class="text-center">
              <div v-if="readonly" class="print-input">{{ tr.출문시간 }}</div>
              <time-selector v-else v-model="tr.출문시간" :readonly="readonly" />
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule.vue";
import SimpleSpinner from "@/components/spinner/SimpleSpinner.vue";
import AlertUserSelector from "@/components/selector/AlertUserSelector.vue";
import FileUploader from "@/components/FileUploader.vue";
import NumberInput from "@/components/NumberInput.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import { 직위옵션 } from "@/views/boards/single-page/976/selectOptions";

export default {
  name: "WorkerList930",
  components: {
    TimeSelector,
    DateSelector,
    NumberInput,
    FileUploader,
    AlertUserSelector,
    SimpleSpinner,
    PhotoUploadGridModule,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "작업자 내역",
    },
    qrList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(value) {
        /**
         * 샘플 데이터 : [
         *   {
         *     id: 'fj832j38',
         *     "userId": 1,
         *     "userName": "홍길동",
         *     "직위직책": "현장소장",
         *     "생년월일": "1990-01-01",
         *     "연락처": "010-1234-5678",
         *     "기초안전보건교육수료증" : {},
         *     "내국인외국인": "",
         *     "건강정보_수축": 0,
         *     "건강정보_이완": 0,
         *     "작업가능여부": "",
         *     "교육만료일자": "",
         *     "입문날짜": "",
         *     "입문시간": "",
         *     "출문날짜": "",
         *     "출문시간": "",
         *   }
         * ]
         */
        this.$emit("input", value);
      },
    },
  },

  data() {
    return {
      selectedUser: [],
      selected: [],
      직위직책옵션: 직위옵션,
    };
  },
  mounted() {},
  methods: {
    addItems() {
      this.$refs.refUserSelector.onClickOpenPopup();
    },

    deleteItems() {
      this.localValue = this.localValue.filter((item) => !this.selected.map((item) => item.userId).includes(item.userId));
      this.selectedUser = this.selectedUser.filter((user) => !this.selected.map((item) => item.userId).includes(user.id));
      this.selected = [];
    },

    onSelectUsers(users) {
      this.selectedUser = users;

      // this.localValue 항목 중에서, users[*].id 가 없는 항목을 제거합니다.
      this.localValue = this.localValue.filter((item) => users.map((user) => user.id).includes(item.userId));

      // users[*].id 가 localValue[*].userId 에 없는 항목을 추가합니다.
      users.forEach((user) => {
        if (!this.localValue.map((item) => item.userId).includes(user.id)) {
          this.localValue.push({
            id: this.generateRandomId(),
            userId: user.id,
            userName: user.name,
            직위직책: "",
            연락처: user.mobile || user.phone || "",
            기초안전보건교육수료증: {},
            내국인외국인: "",
            건강정보_수축: 0,
            건강정보_이완: 0,
            작업가능여부: "",
            교육만료일자: "",
            입문시간: "",
            출문시간: "",
          });
        }
      });

      this.localValue = this.localValue.map((item) => {
        const user = users.find((user) => user.id === item.userId);
        return {
          ...item,
          userName: user.name,
        };
      });

      this.updateQrTime();
    },

    generateRandomId() {
      return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
    },

    refreshEnterExitTime() {
      this.updateQrTime(true);
    },

    /**
     * QR 스캔 데이터를 통해서 입문 시간과 출문 시간을 업데이트한다
     */
    updateQrTime(isForce = false) {
      if (this.qrList.length > 0) {
        this.localValue = this.localValue.map((item) => {
          const userQrs = this.qrList.filter((qr) => qr.user_id === item.userId);
          let enterTime = "";
          let exitTime = "";

          if (userQrs.length > 0) {
            for (const qr of userQrs) {
              // qr.created_at 예시 : 2024-11-08 22:03:17
              const createdAt = new Date(qr.created_at);

              // qr.data === '입문' 이고, createdAt 값이 가장 작은 값이 입문시간
              if (qr.data === "입문") {
                if (enterTime === "" || new Date(enterTime) > createdAt) {
                  enterTime = qr.created_at;
                }
              }

              // qr.data === '출문' 이고, createdAt 값이 가장 큰 값이 출문시간
              if (qr.data === "출문") {
                if (exitTime === "" || new Date(exitTime) < createdAt) {
                  exitTime = qr.created_at;
                }
              }
            }
          }

          if ((!item.입문시간 || isForce) && enterTime) {
            item.입문날짜 = enterTime.split(" ")[0];
            item.입문시간 = enterTime.split(" ")[1];
          }
          if ((!item.출문시간 || isForce) && exitTime) {
            item.출문날짜 = exitTime.split(" ")[0];
            item.출문시간 = exitTime.split(" ")[1];
          }

          return item;
        });
      }

      this.$toast.open({ type: "default", message: "QR 데이터를 불러왔습니다.", position: "bottom", duration: 2000 });
    },
  },
};
</script>

<style lang="scss" scoped>
.table-header {
  font-size: 14px;
  padding: 16px 0 !important;
}
.table::v-deep {
  th,
  th.td-check {
    padding: 16px 10px !important;
  }
  th,
  td {
    border: 1px solid #cdcdcd !important;
  }
  .vs-table--thead {
    z-index: inherit;
  }
}
</style>
